import styled, { css } from 'styled-components';

import { grey10 } from 'constants/variables';
import toRem from 'utils/toRem';

const prefixMap = {
  scheduleGroup: 'schedule_group',
  imageCarousel: 'image_carousel',
  pageImage: 'media',
  grid: 'section',
  marketoForm: 'marketo_form',
};

const excludedTypes = ['quotationBox', 'callToAction', 'heroBanner'];

const SectionTOCLink = ({ href, text }) => (
  <a href={href} className="fs-18 lh-1-5 td-u">
    {text}
  </a>
);

const SectionTOC = ({ title, content, backgroundColor, alignment }) => (
  <SectionTOCWrapper backgroundColor={backgroundColor} alignment={alignment}>
    {title && <p className="fw-800 fs-24 ff-body lh-1-2 mb-24">{title}</p>}

    <SectionTOCMain className="pl-24">
      {content.map(
        ({
          sys: {
            id,
            contentType: {
              sys: { id: contentType },
            },
          },
          fields,
        }) => {
          if (excludedTypes.includes(contentType)) return null;

          const prefix = prefixMap?.[contentType] ?? 'section';
          const sectionTitle = fields?.title;

          return (
            sectionTitle && (
              <SectionTOCLink
                key={`${prefix}_${id}`}
                href={`#${prefix}_${id}`}
                text={sectionTitle}
              />
            )
          );
        },
      )}
    </SectionTOCMain>
  </SectionTOCWrapper>
);

const SectionTOCWrapper = styled.div`
  text-align: left;
  margin-inline: auto;
  margin-block: ${toRem(56)};

  ${({ backgroundColor }) =>
    backgroundColor === 'black'
      ? css`
          a {
            color: inherit;
          }
        `
      : backgroundColor === 'white'
      ? css`
          border-bottom: 1px solid ${grey10};
          padding-bottom: ${toRem(48)};
        `
      : ''}

  ${({ alignment }) =>
    alignment === 'center' &&
    css`
      max-width: 880px;
    `}
`;

const SectionTOCMain = styled.div`
  border-left: 4px solid ${grey10};
  display: flex;
  flex-direction: column;
  gap: ${toRem(16)};
`;

export default SectionTOC;
